import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import PortalLayout from '../components/PortalLayout';

const A = '#00D4AA';
const inputStyle = { width: '100%', padding: 12, fontSize: 15, border: '1px solid #e2e8f0', borderRadius: 10, outline: 'none', boxSizing: 'border-box' };

export default function MeldingMaken() {
  const navigate = useNavigate();
  const [assets, setAssets] = useState([]);
  const [assetId, setAssetId] = useState('');
  const [assetCat, setAssetCat] = useState('');
  const [assetZoek, setAssetZoek] = useState('');
  const [titel, setTitel] = useState('');
  const [beschrijving, setBeschrijving] = useState('');
  const [prioriteit, setPrioriteit] = useState('normaal');
  const [fotos, setFotos] = useState([]);
  const [bezig, setBezig] = useState(false);
  const [ok, setOk] = useState(false);
  const [fout, setFout] = useState('');

  useEffect(() => {
    api.get('/klantportaal/assets').then((r) => setAssets(r.data.assets || [])).catch(() => {});
  }, []);

  const submit = async () => {
    if (!assetId) { setFout('Kies eerst het object / de wissel'); return; }
    if (!titel.trim()) { setFout('Geef kort aan wat er aan de hand is'); return; }
    setBezig(true); setFout('');
    try {
      const fd = new FormData();
      fd.append('klant_id', assetId);
      fd.append('titel', titel);
      if (beschrijving) fd.append('beschrijving', beschrijving);
      fd.append('prioriteit', prioriteit);
      for (const f of fotos) fd.append('fotos', f);
      await api.post('/klantportaal/melding', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setOk(true);
      setTimeout(() => navigate('/'), 1800);
    } catch (e) {
      setFout(e.response?.data?.message || 'Versturen mislukt, probeer opnieuw');
    } finally { setBezig(false); }
  };

  if (ok) {
    return (
      <PortalLayout titel="Melding maken">
        <div style={{ textAlign: 'center', marginTop: 50 }}>
          <div style={{ fontSize: 44 }}>&#x2705;</div>
          <div style={{ fontWeight: 600, color: '#1e293b', marginTop: 10 }}>Melding verstuurd</div>
          <div style={{ color: '#64748b', fontSize: 14, marginTop: 4 }}>We nemen het zo snel mogelijk op.</div>
        </div>
      </PortalLayout>
    );
  }

  const cats = [...new Set(assets.map((a) => a.categorie || 'Overig'))].sort();
  const inCat = assetCat ? assets.filter((a) => (a.categorie || 'Overig') === assetCat) : assets;
  const matches = assetZoek.trim() ? inCat.filter((a) => (a.naam || '').toLowerCase().includes(assetZoek.toLowerCase())) : (assetCat ? inCat : []);
  const gefilterd = matches.slice(0, 100);
  const meer = matches.length - gefilterd.length;

  return (
    <PortalLayout titel="Melding maken">
      <Veld label="Object / wissel *">
        {cats.length > 1 && (
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 10 }}>
            {cats.map((c) => (
              <div key={c} onClick={() => { setAssetCat(assetCat === c ? '' : c); setAssetId(''); setAssetZoek(''); }}
                style={{ padding: '6px 14px', borderRadius: 20, fontSize: 13.5, cursor: 'pointer', fontWeight: 600,
                  background: assetCat === c ? '#00D4AA' : '#fff', color: assetCat === c ? '#fff' : '#64748b',
                  border: '1px solid ' + (assetCat === c ? '#00D4AA' : '#e2e8f0') }}>{c}</div>
            ))}
          </div>
        )}
        <div style={{ position: 'relative' }}>
          <input value={assetZoek} onChange={(e) => { setAssetZoek(e.target.value); setAssetId(''); }} style={inputStyle} placeholder="Zoek op nummer of naam..." />
          {assetId !== '' && (
            <button type="button" onClick={() => { setAssetId(''); setAssetZoek(''); }} style={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)', border: 'none', background: 'transparent', fontSize: 20, cursor: 'pointer', color: '#94a3b8' }}>&times;</button>
          )}
          {(assetZoek.trim() !== '' || assetCat !== '') && assetId === '' && (
            <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: '#fff', border: '1px solid #e2e8f0', borderRadius: 10, marginTop: 4, maxHeight: 220, overflowY: 'auto', zIndex: 50, boxShadow: '0 6px 16px rgba(0,0,0,0.12)' }}>
              {gefilterd.map((a) => (
                <div key={a.id} onClick={() => { setAssetId(String(a.id)); setAssetZoek(a.naam); }} style={{ padding: 12, cursor: 'pointer', borderBottom: '1px solid #f1f5f9', fontSize: 15 }}>{a.naam}{a.plaats ? ' \u00b7 ' + a.plaats : ''}</div>
              ))}
              {meer > 0 && <div style={{ padding: 10, color: '#94a3b8', fontSize: 13, textAlign: 'center', borderTop: '1px solid #f1f5f9' }}>nog {meer} objecten — typ om te verfijnen</div>}
              {gefilterd.length === 0 && <div style={{ padding: 12, color: '#94a3b8', fontSize: 14 }}>Geen object gevonden</div>}
            </div>
          )}
        </div>
      </Veld>
      <Veld label="Wat is er aan de hand? *">
        <input value={titel} onChange={(e) => setTitel(e.target.value)} style={inputStyle} placeholder="Korte omschrijving" />
      </Veld>
      <Veld label="Toelichting">
        <textarea value={beschrijving} onChange={(e) => setBeschrijving(e.target.value)} rows={4} style={{ ...inputStyle, resize: 'vertical', fontFamily: 'inherit' }} placeholder="Wat zie je precies?" />
      </Veld>
      <Veld label="Urgentie">
        <div style={{ display: 'flex', gap: 8 }}>
          {[{ v: 'normaal', l: 'Normaal', c: '#10b981' }, { v: 'hoog', l: 'Hoog', c: '#f59e0b' }, { v: 'urgent', l: 'Urgent', c: '#ef4444' }].map((p) => (
            <button key={p.v} type="button" onClick={() => setPrioriteit(p.v)} style={{ flex: 1, padding: 12, borderRadius: 10, border: '2px solid', borderColor: prioriteit === p.v ? p.c : '#e2e8f0', background: prioriteit === p.v ? p.c : '#fff', color: prioriteit === p.v ? '#fff' : '#1e293b', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>{p.l}</button>
          ))}
        </div>
      </Veld>
      <Veld label="Foto's (optioneel)">
        <input type="file" accept="image/*" multiple capture="environment" onChange={(e) => setFotos(Array.from(e.target.files))} style={{ fontSize: 14 }} />
        {fotos.length > 0 && <div style={{ color: '#64748b', fontSize: 13, marginTop: 6 }}>{fotos.length} foto(s) gekozen</div>}
      </Veld>
      {fout && <div style={{ padding: 10, borderRadius: 8, marginBottom: 12, background: '#fee2e2', color: '#b91c1c', fontSize: 14 }}>{fout}</div>}
      <button onClick={submit} disabled={bezig} style={{ width: '100%', padding: 14, background: A, color: '#fff', border: 'none', borderRadius: 10, fontSize: 15, fontWeight: 700, cursor: bezig ? 'not-allowed' : 'pointer', opacity: bezig ? 0.6 : 1, marginTop: 6 }}>{bezig ? 'Bezig\u2026' : 'Melding versturen'}</button>
    </PortalLayout>
  );
}

const Veld = ({ label, children }) => (
  <div style={{ marginBottom: 14 }}>
    <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#64748b', marginBottom: 6, textTransform: 'uppercase', letterSpacing: 0.5 }}>{label}</label>
    {children}
  </div>
);
